import {createReducer, on} from "@ngrx/store";
import {AttachmentsState} from "@shared/components/attachments/store/attachments.state";
import {AttachmentsActions} from "@shared/components/attachments/store/attachments.actions-type";

export const initialAttachmentsState: AttachmentsState = {
  name: "",
  path: "",
  isLoading: true,
  loadingId: null
};

export const attachmentsStore = createReducer(
  initialAttachmentsState,
  on(AttachmentsActions.getFile, (state, args) => ({
    ...state,
    name: args.name,
    path: args.path,
    isLoading: true,
    loadingId: args.loadingId
  })),
  on(AttachmentsActions.getFileSuccess, (state, args) => ({
    ...state,
    name: args.name,
    isLoading: false,
    loadingId: args.loadingId
  })),
  on(AttachmentsActions.getFileFail, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(AttachmentsActions.openLink, (state, args) => ({
    ...state,
    isLoading: true,
    loadingId: args.loadingId
  })),
  on(AttachmentsActions.openLinkSuccess, (state, args) => ({
    ...state,
    isLoading: false,
    loadingId: args.loadingId
  })),
  on(AttachmentsActions.openLinkFail, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(AttachmentsActions.getKnowledgeArticle, (state, args) => ({
    ...state,
    isLoading: true,
    loadingId: args.loadingId
  })),
  on(AttachmentsActions.getKnowledgeArticleSuccess, (state, args) => ({
    ...state,
    isLoading: false,
    loadingId: args.loadingId
  })),
  on(AttachmentsActions.getKnowledgeArticleFail, (state) => ({
    ...state,
    isLoading: false,
  })),
)
